import { render, staticRenderFns } from "./entrust-dialog.vue?vue&type=template&id=562bc551&scoped=true"
import script from "./entrust-dialog.vue?vue&type=script&lang=js"
export * from "./entrust-dialog.vue?vue&type=script&lang=js"
import style0 from "./entrust-dialog.vue?vue&type=style&index=0&id=562bc551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562bc551",
  null
  
)

export default component.exports